var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpAddressDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5044 4C9.92901 4 4.59863 9.37257 4.59863 16C4.59863 16.4731 4.97962 16.8571 5.44904 16.8571C5.91847 16.8571 6.29946 16.4731 6.29946 16C6.29946 10.3197 10.8687 5.71429 16.5044 5.71429C22.1401 5.71429 26.7093 10.3197 26.7093 16C26.7093 16.4731 27.0895 16.8571 27.5597 16.8571C28.03 16.8571 28.4102 16.4731 28.4102 16C28.4102 9.37257 23.0798 4 16.5044 4Z",
    fill: "#3C4D6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5043 8.28564C12.2769 8.28564 8.85059 11.7391 8.85059 15.9999C8.85059 16.4731 9.23157 16.8571 9.701 16.8571C10.1704 16.8571 10.5514 16.4731 10.5514 15.9999C10.5514 12.6862 13.2166 9.99993 16.5043 9.99993C19.792 9.99993 22.4572 12.6862 22.4572 15.9999C22.4572 16.4731 22.8373 16.8571 23.3076 16.8571C23.7779 16.8571 24.158 16.4731 24.158 15.9999C24.158 11.7391 20.7317 8.28564 16.5043 8.28564Z",
    fill: "#3C4D6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9078 15.9998C19.9138 14.1064 18.3958 12.5661 16.5172 12.5601C14.6387 12.5541 13.1105 14.0841 13.1045 15.9775C13.0994 17.5452 14.1497 18.9166 15.6557 19.3084V26.2855H13.9549C13.4855 26.2855 13.1045 26.6686 13.1045 27.1426C13.1045 27.6166 13.4855 27.9998 13.9549 27.9998H19.0574C19.5277 27.9998 19.9078 27.6166 19.9078 27.1426C19.9078 26.6686 19.5277 26.2855 19.0574 26.2855H17.3566V19.3084C18.855 18.9184 19.9027 17.5589 19.9078 15.9998Z",
    fill: "#3C4D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpAddressDesktop);
export default __webpack_public_path__ + "static/media/ip_address_desktop.3d1302ae84165d8308fabda0e421a751.svg";
export { ForwardRef as ReactComponent };